import { configureStore } from "@reduxjs/toolkit";
import userReducer from "../feature/AuthSlice";

export default configureStore({
    reducer: {
        user: userReducer
    }
});